export default {
  dialog: {
    pmsSite: 'Dùng cho PMS',
    ticketSite: 'Dùng cho bán vé',
    code: 'Mã',
    desc: 'Mô tả',
    user: 'Người dùng',
    titleAdd: 'Thêm thông tin',
    titleCurrencyAdd: 'Thêm tiền tệ',
    titleCurrencyUpdate: 'Sửa tiền tệ',
    titleTaxAdd: 'Thêm thuế',
    titleTaxUpdate: 'Sửa thuế',
    chargeFeeAdd: 'Thêm phí dịch vụ',
    chargeFeeUpdate: 'Sửa phí dịch vụ',
    bankAccountAdd: 'Thêm tài khoản ngân hàng',
    bankAccountUpdate: 'Sửa tài khoản ngân hàng',
    customerProfileAdd: 'Thêm mẫu ghi chú',
    customerProfileUpdate: 'Sửa mẫu ghi chú',
    productCategoryAdd: 'Thêm thông tin danh mục sản phẩm',
    productCategoryUpdate: 'Sửa thông tin danh mục sản phẩm',
    productProductUnitAdd: 'Thêm thông tin đơn vị tính',
    productProductUnitUpdate: 'Sửa thông tin đơn vị tính',
    productAttributeUnitAdd: 'Thêm thông tin thuộc tính',
    productAttributeUnitUpdate: 'Sửa thông tin thuộc tính',
    serviceTypeAdd: 'Thêm thông tin loại sản phẩm/dịch vụ',
    serviceTypeUpdate: 'Sửa thông tin loại sản phẩm/dịch vụ',
    subTransactionTypeAdd: 'Thêm thông tin giao dịch phụ',
    subTransactionTypeUpdate: 'Sửa thông tin giao dịch phụ',
    productAdd: 'Thêm thông tin sản phẩm',
    productAddExcel: 'Nhập từ Excel',
    productUpdate: 'Sửa thông tin sản phẩm',
    transactionDefinitionAdd: 'Thêm định nghĩa giao dịch',
    transactionDefinitionUpdate: 'Sửa định nghĩa giao dịch',
    subTransactionDefinitionAdd: 'Thêm mã giao dịch phụ',
    subTransactionDefinitionUpdate: 'Sửa mã giao dịch phụ',
    configPaymentMethod: 'Cấu hình phương thức thanh toán',
    configPriceType: 'Cấu hình loại giá',
    room: 'Phòng',
    roomLevel: 'Hạng phòng',
    reason: 'Lý do',
    type: 'Loại',
    fromDate: 'Từ ngày',
    toDate: 'Đến ngày',
    returnStatus: 'Trả về trạng thái',
    titleUpdate: 'Sửa thông tin',
    title: {
      receiveRequest: 'Tiếp nhận yêu cầu',
      rejectequest: 'Từ chối yêu cầu',
      completeRequest: 'Hoàn thành yêu cầu'
    },
    titleConfigurationAdd: 'Thêm cấu hình',
    titleConfigurationModify: 'Sửa cấu hình',
    titlePackageCategoryAdd: 'Thêm danh mục gói',
    titlePackageCategoryModify: 'Sửa danh mục gói',
    titlePackageAdd: 'Thêm gói',
    titlePackageModify: 'Sửa gói',
    titleAttributeCategoryUpdate: 'Sửa danh mục thuộc tính',
    titleAttributeCategoryAdd: 'Thêm danh mục thuộc tính',
    titleMaterialQuantificationUpdate: 'Sửa khai báo định lượng',
    titleRateCategoryAdd: 'Thêm danh mục giá',
    titleRateCategoryModify: 'Sửa danh mục giá',
    titlePriceCodeEdit: 'Sửa mã giá',
    titlePriceCodeAdd: 'Thêm mã giá',
    titleSelectionPackageAndPackageGroup: 'Chọn gói, nhóm gói',
    titlePeriod: 'Giai đoạn',
    titleRoomServiceGroupAdd: 'Thêm nhóm dịch vụ buồng phòng',
    titleRoomServiceGroupModify: 'Sửa nhóm dịch vụ buồng phòng',
    titleBreakfastEdit: 'Sửa mã ăn sáng',
    titleBreakfastAdd: 'Thêm mã ăn sáng',
    titleServiceAdd: 'Thêm dịch vụ',
    titleServiceModify: 'Sửa dịch vụ',
    titleRevenueRecognizeTransaction: 'Giao dịch ghi nhận doanh thu',
    titleRoomSurchargeAdd: 'Thêm phụ thu phòng',
    titleRoomSurchargeModify: 'Sửa phụ thu phòng',
    titleRepairLocationAdd: 'Thêm vị trí bảo trì',
    titleRepairLocationEdit: 'Sửa vị trí bảo trì',
    titleTypeOfWorkAdd: 'Thêm loại việc',
    titleTypeOfWorkEdit: 'Sửa loại việc',
    titleOooRoomAdd: 'Thêm phòng không sử dụng, không phục vụ',
    titleOooRoomEdit: 'Sửa phòng không sử dụng, không phục vụ',
    titleHouseKeepingServiceAdd: 'Thêm dịch vụ buồng',
    titleHouseKeepingServiceEdit: 'Sửa dịch vụ buồng',
    titleroomConditionAdd: 'Thêm tình trạng buồng phòng',
    titleroomConditionEdit: 'Sửa tình trạng buồng phòng',
    titleTaskAssignment: 'Phân công dọn phòng',
    taxLevel: 'Mức thuế(%)',
    chargeFeeLevel: 'Mức phí(%)',
    bankCode: 'Mã tài khoản',
    accountNum: 'Số tài khoản',
    bankAccountName: 'Tên ngân hàng',
    active: 'Hoạt động',
    currencyCode: 'Mã tiền tệ',
    decimalDigit: 'Số chữ số thập phân',
    currencyName: 'Tên đơn vị tiền tệ',
    exchangeRate: 'Tỷ giá',
    exchangeRateDebit: 'Tỷ giá hối đoái khoản nợ trả chậm',
    basis: 'Cơ sở',
    devideBasis: 'Chia cho cơ sở',
    mainCategory: 'Danh mục chính',
    codeCategory: 'Mã danh mục',
    viName: 'Tên tiếng Việt',
    enName: 'Tên tiếng Anh',
    target: 'Mục tiêu',
    serviceType: 'Loại dịch vụ',
    titlePackageDetailEdit: 'Sửa chi tiết gói',
    titlePackageDetailAdd: 'Thêm chi tiết gói',
    titleAssignTraveller: 'Gán hồ sơ khách vào đặt phòng',
    titleSpecialService: 'Dịch vụ đặc biệt',
    titleSelectRoom: 'Chọn phòng',
    name: 'Danh xưng',
    birthday: 'Sinh nhật',
    companyName: 'Tên công ty',
    address1: 'Địa chỉ 1',
    address2: 'Địa chỉ 2',
    passport: 'Hộ chiếu',
    marketSegment: 'Phân khúc thị trường',
    gender: 'Giới tính',
    titleCheckoutGroupEdit: 'Sửa thông tin trả phòng đoàn',
    firstName: 'Họ',
    lastName: 'Tên',
    titleAssignServiceToRoomServiceGroup:
      'Gán dịch vụ vào nhóm dịch vụ buồng phòng',
    titlePackageGroupAdd: 'Thêm nhóm gói',
    titlePackageGroupModify: 'Sửa nhóm gói',
    findAndSelectPackForPackGroup: 'Tìm và chọn gói cho nhóm gói',
    unselectedPackList: 'Danh sách gói chưa chọn',
    selectedPackList: 'Danh sách gói đã chọn',
    titleNote: 'Chú thích',
    titleArAccountUpdate: 'Cập nhật tài khoản công nợ',
    titleArAccountAdd: 'Thêm tài khoản công nợ',
    accountNumber: 'Số tài khoản',
    taxCode: 'Mã số thuế',
    address: 'Địa chỉ',
    accountName: 'Tên tài khoản',
    debtDate: 'Số ngày được nợ',
    email: 'Email',
    maxDebtAmmount: 'Số tiền nợ tối đa',
    phoneNumber: 'Số điện thoại',
    debtAccountTitle: 'Tài khoản công nợ',
    payment: 'Thanh toán',
    titleAddPromotion: 'Thêm khuyến mại',
    titleModifyPromotion: 'Cập nhật khuyến mại',
    titleWarehouseUpdate: 'Sửa kho',
    titleWarehouseAdd: 'Thêm kho',
    parentWarehouse: 'Kho cha',
    titleLostAndFoundAdd: 'Thêm thông tin đồ thất lạc',
    titleLostAndFoundEdit: 'Sửa thông tin đồ thất lạc',
    note: 'Ghi chú'
  }
}
